<h1 mat-dialog-title>Plan Details</h1>
<mat-dialog-content>
    <div class="modal-top">
        <div>
            <p class="carrier-name">{{data.plan.carrier.name.toUpperCase()}}</p>
            <p class="plan-name">{{data.plan.name}}</p>
            <div *ngIf="data.plan.lineOfCoverage === 'Medical'">
                <app-metal-level-box [metalLevel]="data.plan.metalLevel"></app-metal-level-box>
                <div class="flex-row">
                    <div class="header-left">Plan Type</div>
                    <div class="header-right">{{data.plan.type}}</div>
                </div>
            </div>
            <div *ngIf="!(data.plan.lineOfCoverage === 'Accident' || data.plan.lineOfCoverage === 'HospitalIndemnity' || data.plan.lineOfCoverage === 'CriticalIllness')" class="flex-row">
                <div class="header-left">Monthly Premium </div>
                <div class="header-right">{{utils.formatCurrency(data.plan.premium)}}</div>
            </div>
            <div *ngIf="data.plan.isRenewal" class="plan-cr">
                Renewal
            </div>
        </div>
        <div>
            <img *ngIf="data.plan.carrierLogoUrl" src="{{data.plan.carrierLogoUrl}}" />
        </div>
    </div>
    <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="benefit">
            <th mat-header-cell *matHeaderCellDef> Benefit </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="inValue">
            <th mat-header-cell *matHeaderCellDef>
                <div *ngIf="!(data.plan.lineOfCoverage === 'Accident' || data.plan.lineOfCoverage === 'HospitalIndemnity' || data.plan.lineOfCoverage === 'CriticalIllness')" >
                    <span>In Network</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.inValue}} </td>

        </ng-container>
        <ng-container matColumnDef="outValue">
                <th mat-header-cell *matHeaderCellDef>
                    <div *ngIf="!(data.plan.lineOfCoverage === 'Accident' || data.plan.lineOfCoverage === 'HospitalIndemnity' || data.plan.lineOfCoverage === 'CriticalIllness')" >
                        <span>Out of Network</span>
                    </div>
                </th>
            <td mat-cell *matCellDef="let element"> {{element.outValue}} </td>

        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">CANCEL</button>
  <button mat-raised-button class="mat-button select-plan-button" (click)="onYesClick()" cdkFocusInitial>SELECT PLAN</button>
</div>
